import { useEffect, useState } from "react";
import "../commonlayouts/employerlayout.css";
import { Link, useNavigate } from "react-router-dom";
import FooterLayout from "./beforeloginfooter";
import DropdownMenu from "./dropdownmenu";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useCountry } from "../contexts/countrycodecontext.js";
import { GetCountries, GetCountryIdOfUsers } from "../apiconstants/constants.js";
import { useUserType } from "../contexts/usertypecontext";

const ConsultantLayout = ({ children }) => {

  const [Countries, SetCountries] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const { selectedCountry, updateCountryCode } = useCountry();
  const { selectedUserType, setSelectedUserType } = useUserType();


// -------------------------------------------
// ✅ NORMALIZE LOGIN USER TYPE
// -------------------------------------------
// Convert null / "null" / ""  → multi-role (Admin mode)
let rawLoginType = localStorage.getItem("usertype");

let loginType = (!rawLoginType || rawLoginType === "null" || rawLoginType.trim() === "")
  ? "recruiter,benchsales"
  : rawLoginType;


// -------------------------------------------
// ✅ BUILD AVAILABLE ROLES FROM LOGIN
//    Login determines what OPTIONS you can select
// -------------------------------------------
const userTypesAvailable =
  loginType.includes(",")
    ? ["Recruiter", "Bench Sales"]   // multi-role → show both (Admin Mode)
    : [loginType === "Recruiter" ? "Recruiter" : "Bench Sales"];

// -------------------------------------------
// ✅ SET DEFAULT SELECTED TYPE
//    Only IF nothing selected yet
// -------------------------------------------
useEffect(() => {
  if (!selectedUserType) {
    if (userTypesAvailable.length > 1) {
      setSelectedUserType("Admin");   // Admin-mode when both are available
    } else {
      setSelectedUserType(userTypesAvailable[0]);
    }
  }
}, [userTypesAvailable]);


// -------------------------------------------
// ✅ COMPUTE ROLE FLAGS FROM SELECTED VALUE
//    selectedUserType controls sidebar visibility
// -------------------------------------------
const isRecruiter  = selectedUserType === "Recruiter";
const isBenchSales = selectedUserType === "Bench Sales";
const isAdmin      = selectedUserType === "Admin";


  const [isOpen, setIsopen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpen3, setDropdownOpen3] = useState(false);
  const navigate = useNavigate();

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleDropdown1 = () => setDropdownOpen1(!dropdownOpen1);
  const toggleDropdown2 = () => setDropdownOpen2(!dropdownOpen2);
  const toggleDropdown3 = () => setDropdownOpen3(!dropdownOpen3);

  const roleID = localStorage.getItem("roleID");
  const guid = localStorage.getItem("guid");
  const token = localStorage.getItem("jwtToken");
  const isSubscriptionActive = localStorage.getItem("isSubscriptionActive");
  const islogin = localStorage.getItem("tokenid");
  const logo = JSON.parse(localStorage.getItem("clientData"))?.logoURL;

  let Guid="";


const employerGuid = localStorage.getItem("employerGuid")
const email = localStorage.getItem("email")


if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}
useEffect(() => {
  if (!selectedUserType) {
    if (userTypesAvailable.includes("Admin")) setSelectedUserType("Admin");
    else setSelectedUserType(userTypesAvailable[0]); // Recruiter / Bench Sales
  }
}, [userTypesAvailable]);

  useEffect(() => { if (!islogin) navigate("/Login"); }, [islogin, navigate]);

  const getCountriesFromLocalStorage = () => JSON.parse(localStorage.getItem("countries")) || [];

  const fetchUserCountries = async () => {
    try {
      if (!guid) return;
      const data = await (await fetch(`${GetCountryIdOfUsers.APIURL}?Guid=${guid}`,
      { headers: {
        Authorization: `Bearer ${token}`,
      }
    }
      )).json();
      if (data?.length && data[0]?.countryID) {
        const ids = data[0].countryID.split(",").map((i) => i.trim());
      const allCountries = await fetch(GetCountries.APIURL, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  }).then(res => res.json());
        const allowed = allCountries.filter((c) => ids.includes(String(c.countryID)));
        if (allowed.length) {
          SetCountries(allowed);
          localStorage.setItem("countries", JSON.stringify(allowed));
          const defaultId = allowed[0].countryID.toString();
          if (!selectedCountry) updateCountryCode(defaultId);
          setSelectedCountryCode(selectedCountry || defaultId);
        }
      }
    } catch (err) { console.error("Error fetching user countries:", err); }
  };

  useEffect(() => {
    const stored = getCountriesFromLocalStorage();
    if (stored.length) {
      SetCountries(stored);
      const def = stored[0].countryID.toString();
      setSelectedCountryCode(selectedCountry || def);
    } else fetchUserCountries();
  }, [selectedCountry]);

  const ToggleSidebar = () => setIsopen(!isOpen);
  const navigateToDashboard = () => {
    if (roleID === "2") navigate("/Employer/Dashboard");
    else if (roleID === "3") navigate("/Employer/UserDashboard");
    else if (roleID === "4") navigate("/Employer/CEMDashboard");
    else navigate("/");
  };

  const handleCountryChange = (e) => {
    const val = e.target.value;
    setSelectedCountryCode(val);
    updateCountryCode(val);
  };

  return (
    <>
      <div className="container-fluid mt-3">
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-md">
          <div className="container-fluid p-2">
            <div className="btn btn-primary" onClick={ToggleSidebar}><i className="fa fa-bars"></i></div>
            <div className="form-inline ml-auto">
              <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Country Filter</Tooltip>}>
                <select value={selectedCountryCode} onChange={handleCountryChange} disabled={Countries.length === 1}
                  style={{ width: "160px", marginRight: "15px", borderRadius: "8px", padding: "5px", border: "1px solid #00a7ac", marginTop: 10 }}>
                  {Countries.map((c) => <option key={c.countryID} value={c.countryID}>{c.country || c.countryName}</option>)}
                </select>
              </OverlayTrigger>
   {/* Hide dropdown completely when multi-role */}
{userTypesAvailable.length === 1 ? (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip">User Type Filter</Tooltip>}
  >
    <select
      value={selectedUserType}
      onChange={(e) => setSelectedUserType(e.target.value)}
      style={{
        width: "160px",
        borderRadius: "8px",
        padding: "5px",
        border: "1px solid #00a7ac",
        marginTop: 10,
        marginRight: 15,
      }}
    >
      <option value={selectedUserType}>{selectedUserType}</option>
    </select>
  </OverlayTrigger>
) : (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip">User Type Filter</Tooltip>}
  >
    <select
      value={selectedUserType}
      onChange={(e) => setSelectedUserType(e.target.value)}
      style={{
        width: "160px",
        borderRadius: "8px",
        padding: "5px",
        border: "1px solid #00a7ac",
        marginTop: 10,
        marginRight: 15,
      }}
    >
      {userTypesAvailable.map((type) => (
        <option key={type} value={type}>
          {type}
        </option>
      ))}
    </select>
  </OverlayTrigger>
)}




              <img src={logo} height={45} alt="Logo" style={{ marginTop: 10 }} />
            </div>
          </div>
        </nav>

        {/* Sidebar */}
        <div className={`sidebar ${isOpen ? "active" : ""}`}>
          <div className="sd-header">
            <img src={logo} height={45} alt="Logo" />
            <div className="btn btn-primary" onClick={ToggleSidebar}><i className="fa fa-times"></i></div>
          </div>

          <div className="sd-body">
            <ul>
              {(roleID === "2" || roleID === "3" || roleID === "4") && isSubscriptionActive == "true" &&
                <li onClick={navigateToDashboard}><Link className="sd-link">Dashboard</Link></li>}

              {(roleID === "2" || roleID === "3") && isSubscriptionActive == "true" && <>
{!isBenchSales && (
  <li><Link to="/Employer/ListOfJobPosts" className="sd-link">Post a Job</Link></li>
)}

                {/* Candidate Pool */}
                {/* <li className="dropdown" onClick={toggleDropdown2}>
                  <span className="sd-link" style={{ fontSize: 14 }}>Candidate Pool <span className="dropdown-icon mt-1" style={{ fontSize: 12, float: "right" }}>&#9660;</span></span>
                  {dropdownOpen2 && <ul className="dropdown-menu">
                    <li><Link to="/Employer/GetCandidatesByEmployerUserID" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">External</Link></li>
                    <li><Link to="/Employer/InternalBench" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Internal</Link></li>
                  </ul>}
                </li> */}

                {(roleID === "2" || roleID === "3") && (
  <li className="dropdown" onClick={toggleDropdown2}>
    <span className="sd-link" style={{ fontSize: 14 }}>
      Candidate Pool
      <span className="dropdown-icon mt-1" style={{ fontSize: 12, float: "right" }}>
        &#9660;
      </span>
    </span>

   {dropdownOpen2 && (
  <ul className="dropdown-menu">

    {/* -------- MULTI-ROLE (Admin or recruiter+benchsales) -------- */}
    {userTypesAvailable.length > 1 || isAdmin ? (
      <>
        <li>
          <Link
            to="/Employer/GetCandidatesByEmployerUserID"
            className="sd-link"
            style={{ color: "#fff", backgroundColor: "#00a7ac" }}
          >
            External
          </Link>
        </li>
        <li>
          <Link
            to="/Employer/InternalBench"
            className="sd-link"
            style={{ color: "#fff", backgroundColor: "#00a7ac" }}
          >
            Internal
          </Link>
        </li>
      </>
    ) : (
      <>
        {/* -------- Recruiter only -------- */}
        {isRecruiter && (
          <li>
            <Link
              to="/Employer/GetCandidatesByEmployerUserID"
              className="sd-link"
              style={{ color: "#fff", backgroundColor: "#00a7ac" }}
            >
              External
            </Link>
          </li>
        )}

        {/* -------- Bench Sales only -------- */}
        {isBenchSales && (
          <li>
            <Link
              to="/Employer/InternalBench"
              className="sd-link"
              style={{ color: "#fff", backgroundColor: "#00a7ac" }}
            >
              Internal
            </Link>
          </li>
        )}
      </>
    )}

  </ul>
)}

  </li>
)}

                 {/* Assessment */}
              {!isBenchSales && (
    <li className="dropdown" onClick={toggleDropdown}>
                    <span className="sd-link" style={{ fontSize: 14 }}>Assessment <span className="dropdown-icon mt-1" style={{ fontSize: 12, float: "right" }}>&#9660;</span></span>
                    {dropdownOpen && <ul className="dropdown-menu">
                      <li><Link to="/Employer/GetInterviewScheduledCandidates" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Schedules</Link></li>
                      <li><Link to="/Employer/GetInterviewCompletedCandidates" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Completed</Link></li>
                    </ul>}
                  </li>
)}


                {/* Reports */}
                <li className="dropdown" onClick={toggleDropdown1}>
                  <span className="sd-link" style={{ fontSize: 14 }}>Reports <span className="dropdown-icon mt-1" style={{ fontSize: 12, float: "right" }}>&#9660;</span></span>
                  {/* {dropdownOpen1 && <ul className="dropdown-menu">
                    <li><Link to="/Employer/Reports" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Recruiters</Link></li>
                    <li><Link to="/Employer/ViewBenchSalesReports" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Bench Sales</Link></li>
                  </ul>} */}

                {dropdownOpen1 && (
  <ul className="dropdown-menu">

    {/* MULTI-ROLE or ADMIN → SHOW BOTH */}
    {userTypesAvailable.length > 1 || isAdmin ? (
      <>
        <li>
          <Link
            to="/Employer/Reports"
            className="sd-link"
            style={{ color: "#fff", backgroundColor: "#00a7ac" }}
          >
            Recruiters
          </Link>
        </li>
        <li>
          <Link
            to="/Employer/ViewBenchSalesReports"
            className="sd-link"
            style={{ color: "#fff", backgroundColor: "#00a7ac" }}
          >
            Bench Sales
          </Link>
        </li>
      </>
    ) : (
      <>
        {/* Recruiter only */}
        {isRecruiter && (
          <li>
            <Link
              to="/Employer/Reports"
              className="sd-link"
              style={{ color: "#fff", backgroundColor: "#00a7ac" }}
            >
              Recruiters
            </Link>
          </li>
        )}

        {/* Bench Sales only */}
        {isBenchSales && (
          <li>
            <Link
              to="/Employer/ViewBenchSalesReports"
              className="sd-link"
              style={{ color: "#fff", backgroundColor: "#00a7ac" }}
            >
              Bench Sales
            </Link>
          </li>
        )}
      </>
    )}

  </ul>
)}


                </li>
                 {/* Search */}
              {Guid=='cc9d452a-e2ce-4a2a-9154-14725ee7a3ea'&&
                <li className="dropdown" onClick={toggleDropdown3}>
                  <span className="sd-link" style={{ fontSize: 14 }}>Search <span className="dropdown-icon mt-1" style={{ fontSize: 12, float: "right" }}>&#9660;</span></span>
                  {dropdownOpen3 && <ul className="dropdown-menu">
                    <li><Link to="/Employer/ListofLinkedInContacts" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">LinkedIn</Link></li>
{!isBenchSales && (
  <li>
    <Link to="/Employer/DiceSearch" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">
      Dice
    </Link>
  </li>
)}
                  </ul>}
                </li>}
                <li><Link to="/Employer/AIResumeInsights" className="sd-link">AI Resume Insights</Link></li>
{!isBenchSales && (
  <li><Link to="/Employer/Questions" className="sd-link">Question Bank</Link></li>
)}
                {guid === "9d88d6b4-c7b2-4550-91ba-c25cd396ac9f" && <li><Link to="/Employer/ListOfLeads" className="sd-link">Leads</Link></li>}
                <li><Link to="/Employer/ListofStaffingContacts" className="sd-link">Staffing Contacts</Link></li>
                <li><Link to="/Employer/ResumeFormatter" className="sd-link">Resume Formatter</Link></li>
                <li><Link to="/Employer/ListOfResources" className="sd-link" onClick={toggleDropdown}>Resources</Link></li>
                <li><Link to="/Employer/Joinmeeting" className="sd-link">Join Meeting</Link></li>
              </>}

              {roleID === "2" && <li><Link to="/Employer/SubscriptionPlans" className="sd-link">Subscription Details</Link></li>}
              {roleID === "2" && isSubscriptionActive == "true" && <DropdownMenu />}
              <li className="mb-5"><Link to="/Logout" className="sd-link">Logout</Link></li>
            </ul>
          </div>
        </div>

        <div className={`sidebar-overlay ${isOpen ? "active" : ""}`} onClick={ToggleSidebar}></div>
        <div className="container-fluid">{children}</div>
      </div>

      <div style={{ marginTop: 400 }}><FooterLayout /></div>
    </>
  );
};

export default ConsultantLayout;
